export default "__VITE_PUBLIC_ASSET__de431001__"